import SupplyPikeConsent from "./SupplyPikeConsent";

export { SupplyPikeConsent };

export default SupplyPikeConsent;
